module.exports = __webpack_public_path__ + "media/focus_skill/focus_skill-06236419.svg";